package com.arena_web.data.repository

import com.arena_web.data.api.FootballApi
import com.arena_web.data.api.NewsApi
import com.arena_web.data.dto.FootballCompetitionDto
import com.arena_web.data.dto.FootballMatchDto
import com.arena_web.data.dto.FootballStandingsDto
import com.arena_web.data.dto.HeadToHeadDto
import com.arena_web.data.dto.MatchDetailDto
import com.arena_web.data.dto.PlayerDetailDto
import com.arena_web.data.dto.TeamDetailDto
import com.arena_web.data.dto.NewsArticleDto
import com.arena_web.data.dto.NewsPageDto
import com.arena_web.domain.repositories.NewsRepository

class NewsRepositoryImpl(
    private val newsApi: NewsApi,
    private val footballApi: FootballApi,
) : NewsRepository {

    override suspend fun getNews(params: Map<String, String>): Result<NewsPageDto> =
        apiCall { newsApi.getNews(params) }

    override suspend fun getArticle(id: String, locale: String?): Result<NewsArticleDto> =
        apiCall { newsApi.getArticle(id, locale) }

    override suspend fun getCompetitions(sport: String): Result<List<FootballCompetitionDto>> =
        apiCall { footballApi.getCompetitions(sport) }

    override suspend fun getMatches(sport: String, date: String, competition: String?): Result<List<FootballMatchDto>> =
        apiCall { footballApi.getMatches(sport, date, competition) }

    override suspend fun getStandings(sport: String, code: String): Result<FootballStandingsDto> =
        apiCall { footballApi.getStandings(sport, code) }

    override suspend fun getNextMatchday(sport: String, from: String): Result<String> =
        apiCall { footballApi.getNextMatchday(sport, from) }.mapCatching { it.getValue("date") }

    override suspend fun getMatchDetail(
        sport: String,
        id: String,
        date: String,
        competition: String?,
        home: String?,
        away: String?,
    ): Result<MatchDetailDto> =
        apiCall { footballApi.getMatchDetail(sport, id, date, competition, home, away) }

    override suspend fun getTeamDetail(sport: String, teamId: String, locale: String?): Result<TeamDetailDto> =
        apiCall { footballApi.getTeamDetail(sport, teamId, locale) }

    override suspend fun getHeadToHead(sport: String, id: String): Result<HeadToHeadDto> =
        apiCall { footballApi.getHeadToHead(sport, id) }

    override suspend fun getPlayer(sport: String, playerId: String, locale: String?): Result<PlayerDetailDto> =
        apiCall { footballApi.getPlayer(sport, playerId, locale) }
}
